﻿enum InstallationLadingPage {
	Auto,
	CreatePermit,
	PermitsList
}

export default InstallationLadingPage;
